import { TextInputProps, TextInput as MantineTextInput } from '@mantine/core';
import { forwardRef, memo } from 'react';

import { useInputStyles } from './styles';

type TextInputType = React.ForwardRefExoticComponent<
  TextInputProps & React.RefAttributes<HTMLInputElement>
>;

function TextInput(props: TextInputProps, ref: React.Ref<HTMLInputElement>) {
  const {
    classNames,
    wrapperProps,
    disabled,
    rightSectionWidth,
    iconWidth,
    ...rest
  } = props;
  const { classes } = useInputStyles(
    {
      rightSectionWidth,
      iconWidth,
    },
    {
      classNames,
      name: 'TextInput',
    },
  );

  return (
    <MantineTextInput
      disabled={disabled}
      wrapperProps={{
        'data-disabled': disabled,
        ...wrapperProps,
      }}
      classNames={classes}
      ref={ref}
      {...rest}
    />
  );
}
export default memo(
  forwardRef<HTMLInputElement, TextInputProps>(TextInput),
) as TextInputType;
